import { TFunction } from "i18next"
import * as z from "zod"

export type CustomerSearchFilters = {
  page: number
  searchText: string
}

export const createUseNotificationSchema = () => {
  return z.object({
    kakaoTalk: z.boolean().optional(),
    email: z.boolean().optional(),
  })
}
export type UseNotificationFormValues = z.infer<
  ReturnType<typeof createUseNotificationSchema>
>

export const createCustomerStaffSchema = (t: TFunction) => {
  return z.object({
    email: z.string().min(1, t("validation.required")).email(t("validation.email")),
    displayName: z.string().optional(),
    telephone: z.string().optional(),
    useNotification: createUseNotificationSchema(),
  })
}

export type CustomerStaffFormValues = z.infer<
  ReturnType<typeof createCustomerStaffSchema>
>

export const createCustomerFormSchema = (t: TFunction) => {
  return z.object({
    id: z.number().optional(),
    businessRegistrationNumber: z.string().min(1, t("validation.required")),
    organizationName: z.string().min(1, t("validation.required")),
    representativeName: z.string().min(1, t("validation.required")),
    staffs: z.array(createCustomerStaffSchema(t)).nullish().default([]),
    address: z.string().optional(),
    businessItem: z.string().optional(),
    businessType: z.string().optional(),
    taxRegistrationId: z.string().optional(),
    memo: z.string().optional(),
  })
}

export type CustomerFormValues = z.infer<ReturnType<typeof createCustomerFormSchema>>
